import { render, staticRenderFns } from "./CardId.vue?vue&type=template&id=4f03dbb8&scoped=true"
import script from "./CardId.vue?vue&type=script&lang=js"
export * from "./CardId.vue?vue&type=script&lang=js"
import style0 from "./CardId.vue?vue&type=style&index=0&id=4f03dbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f03dbb8",
  null
  
)

export default component.exports